import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20modern%20product%20showcase%20with%20organized%20fashion%20items%20including%20shoes%2C%20folded%20clothing%20and%20accessories%20arranged%20on%20a%20clean%20cream%20marble%20surface%2C%20warm%20natural%20window%20light%20casting%20soft%20shadows%2C%20editorial%20lifestyle%20photography%2C%20minimalist%20aesthetic%20with%20gentle%20neutral%20tones%2C%20sophisticated%20retail%20display%20composition&width=1600&height=900&seq=vigorbuy-hero-v2&orientation=landscape"
        alt="Vigorbuy Spreadsheet product showcase with organized fashion items and shopping resources"
        title="Vigorbuy Spreadsheet - Ultimate Product Guide"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          The Ultimate Vigorbuy Spreadsheet Resource Center
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-[650px] mx-auto mb-10 leading-relaxed">
          Find updated Vigorbuy Spreadsheet guides, product recommendations, QC insights and beginner tutorials — all in one trusted resource hub.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteConfig.mainSite}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap"
          >
            Explore Vigorbuy Spreadsheet
          </a>
          <a
            href="/article/vigorbuy-spreadsheet-beginner-guide"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm font-medium text-sm rounded-full border border-white/30 transition-all whitespace-nowrap"
          >
            Start Beginner Guide
          </a>
        </div>
      </div>
    </section>
  );
}